import { CopyIcon, PackageIcon, type NavItem } from '@huaca/ui';

/**
 * claro's two destinations in the shell's side rail.
 *
 * ITS OWN MODULE, not a constant inside App.tsx, because App.tsx imports `config`, which THROWS at
 * import time when VITE_API_BASE is unset. That is correct for an app bootstrap and fatal for a
 * test: the permission string below is the one thing here worth guarding, and a guard that cannot
 * import the value it guards is not a guard. Pure data, no side effects, importable anywhere.
 *
 * Both labels are the screens' OWN <h1> text, copied rather than reinvented — Dashboard.tsx:53 and
 * TemplateList.tsx:33 — so the rail and the page a click lands on cannot come to disagree about
 * what the screen is called.
 *
 * `claro:template:read` is why the rail takes a permission STRING rather than a rendered element:
 * `can()` works only inside a component under AuthProvider, so a module-level constant like this
 * one cannot call it, and the shell evaluates it instead. The string is verified against the
 * backend catalogue (huaca/src/products/claro/roles.ts:15 and :25) — it is held by BOTH claro.editor
 * and claro.agent, which is the point of gating on `:read` rather than `:edit`: an agent reaches the
 * read-only template list, and TemplateList keeps every create/edit/archive action behind
 * `claro:template:edit` separately. Gating the rail item on `:edit` would hide the list from the
 * role that is allowed to read it.
 *
 * A WRONG STRING HERE IS INVISIBLE. `can` returns false for anything unrecognised, so a typo does
 * not throw — the item simply never appears, for everyone, forever, and no test that renders the
 * rail would notice because there is no markup to assert on. Hence the check against the backend.
 *
 * `matchPrefix` keeps the item lit on /templates/new and /templates/:id, which is where somebody
 * spends the longest and where losing your place in the nav costs the most.
 */
export const NAV_ITEMS: NavItem[] = [
  { path: '/', label: 'מפרטי לקוחות', icon: <PackageIcon /> },
  { path: '/templates', label: 'תבניות', icon: <CopyIcon />, permission: 'claro:template:read', matchPrefix: true },
];
